module.exports = __webpack_public_path__ + "fonts/WorkSans-Roman-VariableFont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/WorkSans/WorkSans-Roman-VariableFont.woff2
// module id = 3485
// module chunks = 0